import { gql } from '@apollo/client'

export const SEND_ACTIVATION_EMAIL_MUTATION = gql`
  mutation($input: SendActivationEmailInput!) {
    sendActivationEmail(input: $input)
  }
`